// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addDotBtnsAndClickHandlers, addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("cards-parcours", (element, {}, { cleanup }) => {
  const dom = {
    viewportNode: ensureHTMLElement(element.querySelector(".c-cards-parcours__slider-viewport")),
    pagination: ensureHTMLElement(element.querySelector(".c-slider-pagination")),
    nextBtnNode: element.querySelector(".c-cards-parcours__btn-next"),
    prevBtnNode: element.querySelector(".c-cards-parcours__btn-prev"),
  };

  const OPTIONS = { align: "start", slidesToScroll: 1 } as const;
  const slider = EmblaCarousel(dom.viewportNode, OPTIONS);

  const removePaginationHandlers = addDotBtnsAndClickHandlers(slider, {
    dotsNode: dom.pagination,
  });

  let removePrevNextHandlers: (() => void) | null = null;
  if (dom.nextBtnNode && dom.prevBtnNode) {
    removePrevNextHandlers = addPrevNextBtnsClickHandlers(slider, {
      nextBtn: ensureHTMLElement(dom.nextBtnNode),
      prevBtn: ensureHTMLElement(dom.prevBtnNode),
    });
  }

  slider.on("destroy", () => {
    removePaginationHandlers();
    removePrevNextHandlers?.();
  });

  cleanup(() => {
    slider.destroy();
  });
});
